(function () {
  if (window.__offhooCollectionJsBound) return;
  window.__offhooCollectionJsBound = true;

  var activeAbortController = null;
  var infiniteScrollCleanups = new WeakMap();
  var drawerLastTrigger = null;

  function getFocusable(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function getCollectionRoot(fromEl) {
    return fromEl && fromEl.closest ? fromEl.closest('[data-offhoo-collection]') : null;
  }

  function getActiveCollectionRoot() {
    return document.querySelector('[data-offhoo-collection]');
  }

  function getSectionId(root) {
    if (!root) return '';
    if (root.dataset.sectionId) return root.dataset.sectionId;

    var sectionEl = root.closest('[id^="shopify-section-"]');
    if (!sectionEl || !sectionEl.id) return '';
    return sectionEl.id.replace(/^shopify-section-/, '');
  }

  function getShopifySectionEl(sectionId, root) {
    if (sectionId) {
      var byId = document.getElementById('shopify-section-' + sectionId);
      if (byId) return byId;
    }
    return root ? root.closest('[id^="shopify-section-"]') : null;
  }

  function findIncomingSection(doc, sectionId) {
    if (!doc) return null;
    if (sectionId) {
      var byId = doc.getElementById('shopify-section-' + sectionId);
      if (byId) return byId;
    }
    return doc.querySelector('[id^="shopify-section-"]');
  }

  function stripScripts(node) {
    if (!node || !node.querySelectorAll) return node;
    node.querySelectorAll('script').forEach(function (script) {
      script.remove();
    });
    return node;
  }

  function normalizePathname(pathname) {
    if (!pathname || pathname === '/') return pathname || '/';
    return pathname.replace(/\/+$/, '') || '/';
  }

  function normalizeUrl(pageUrl) {
    var url = new URL(pageUrl.toString(), window.location.origin);
    url.pathname = normalizePathname(url.pathname);
    return url;
  }

  function getCheckedOfertaFilter(root) {
    var scope = root || document;
    return scope.querySelector('[data-offhoo-tag-filter]:checked');
  }

  function getSubcategoryGroup(root) {
    var scope = root || document;
    return scope.querySelector('[data-offhoo-menu-subcategory-group]');
  }

  function getSubcategoryGroups(root) {
    var scope = root || document;
    return Array.from(scope.querySelectorAll('[data-offhoo-menu-subcategory-group]'));
  }

  function getSelectedSubcatHandles(group) {
    if (!group) return [];
    return Array.from(group.querySelectorAll('[data-offhoo-menu-subcategory]:checked'))
      .map(function (input) {
        return (input.dataset.handle || '').trim();
      })
      .filter(Boolean);
  }

  function getSelectedSubcatItems(group) {
    if (!group) return [];
    return Array.from(group.querySelectorAll('[data-offhoo-menu-subcategory]:checked'))
      .map(function (input) {
        return {
          handle: (input.dataset.handle || '').trim(),
          label: (input.dataset.label || input.dataset.handle || '').trim(),
        };
      })
      .filter(function (item) {
        return item.handle;
      });
  }

  function readSubcatsFromUrl(url) {
    var params = url instanceof URL ? url.searchParams : new URLSearchParams(window.location.search);
    var raw = params.get('subcats') || '';
    if (!raw) return [];
    return raw
      .split(/[+,]/)
      .map(function (part) {
        return decodeURIComponent(part).trim();
      })
      .filter(Boolean);
  }

  function syncSubcatsQuery(url, root) {
    var group = getSubcategoryGroup(root);
    var handles = getSelectedSubcatHandles(group);
    if (!handles.length) {
      handles = readSubcatsFromUrl(url);
    }
    if (handles.length > 0) {
      url.searchParams.set('subcats', handles.join('+'));
    } else {
      url.searchParams.delete('subcats');
    }
    return url;
  }

  function setSubcategoryInputActive(input, isActive) {
    input.checked = !!isActive;
    if (isActive) {
      input.setAttribute('aria-current', 'page');
    } else {
      input.removeAttribute('aria-current');
    }
  }

  function readActiveSubcatHandles(root) {
    var handles = readSubcatsFromUrl(window.location);
    if (handles.length) return handles;

    // Single L3: /collections/{l3-handle}[/tags] — no ?subcats= param.
    var pathHandle = splitCollectionPath(window.location.pathname).handle;
    if (!pathHandle) return [];

    var groups = getSubcategoryGroups(root);
    var matched = false;
    groups.forEach(function (group) {
      var parentHandle = (group.dataset.parentHandle || '').trim();
      if (parentHandle && parentHandle === pathHandle) return;
      group.querySelectorAll('[data-offhoo-menu-subcategory]').forEach(function (input) {
        if ((input.dataset.handle || '').trim() === pathHandle) matched = true;
      });
    });
    return matched ? [pathHandle] : [];
  }

  function syncSubcategoryCheckboxesFromUrl(root) {
    var groups = getSubcategoryGroups(root);
    if (!groups.length) return;

    var handles = readActiveSubcatHandles(root);
    if (!handles.length) {
      // Keep Liquid-checked state when we cannot infer selection from the URL.
      return;
    }

    groups.forEach(function (group) {
      group.querySelectorAll('[data-offhoo-menu-subcategory]').forEach(function (input) {
        var handle = (input.dataset.handle || '').trim();
        setSubcategoryInputActive(input, handles.indexOf(handle) !== -1);
      });
    });
  }

  function ensureActiveFiltersContainer(form) {
    if (!form) return null;
    var existing = form.querySelector('.offhoo-active-filters');
    if (existing) return existing;

    var container = document.createElement('div');
    container.className = 'offhoo-active-filters';
    container.setAttribute('data-offhoo-active-filters-created', '');

    var heading = form.querySelector('.offhoo-collection-filters__heading');
    if (heading && heading.parentNode) {
      heading.parentNode.insertBefore(container, heading.nextSibling);
    } else {
      form.insertBefore(container, form.firstChild);
    }
    return container;
  }

  function syncSubcategoryActiveChips(root) {
    if (!root) return;

    var groups = getSubcategoryGroups(root);
    var selected = groups.length ? getSelectedSubcatItems(groups[0]) : [];

    root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
      form.querySelectorAll('[data-offhoo-subcat-clear]').forEach(function (chip) {
        chip.remove();
      });

      var container = form.querySelector('.offhoo-active-filters');

      if (!selected.length) {
        if (container && container.hasAttribute('data-offhoo-active-filters-created') && !container.children.length) {
          container.remove();
        }
        return;
      }

      container = ensureActiveFiltersContainer(form);
      if (!container) return;

      var fragment = document.createDocumentFragment();
      selected.forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'offhoo-active-filter';
        button.setAttribute('data-offhoo-subcat-clear', '');
        button.dataset.handle = item.handle;
        button.appendChild(document.createTextNode(item.label));
        button.appendChild(document.createTextNode(' '));
        var closeMark = document.createElement('span');
        closeMark.setAttribute('aria-hidden', 'true');
        closeMark.textContent = '×';
        button.appendChild(closeMark);
        fragment.appendChild(button);
      });
      container.insertBefore(fragment, container.firstChild);
    });
  }

  function getOfertaFilterLabel(form) {
    var input = form && form.querySelector('[data-offhoo-tag-filter]');
    if (input && input.id) {
      var label = form.querySelector('label[for="' + input.id + '"]');
      var labelText = label && (label.querySelector('span') || label);
      if (labelText && labelText.textContent) return labelText.textContent.trim();
    }
    return 'Oferta';
  }

  function isOfertaActiveFromLocation(root) {
    var sample = (root || document).querySelector('[data-offhoo-tag-filter]');
    var ofertaTag = (sample && sample.dataset.tag) || '';
    ofertaTag = ofertaTag.trim();
    if (!ofertaTag) return false;
    return splitCollectionPath(window.location.pathname).tags.indexOf(ofertaTag) !== -1;
  }

  function findOfertaActiveChip(form) {
    if (!form) return null;
    return (
      form.querySelector('.offhoo-active-filters [data-offhoo-oferta-clear]') ||
      form.querySelector('.offhoo-active-filters a[data-offhoo-preserve-query]')
    );
  }

  /**
   * Multi-select catalog skips section HTML replace — keep Oferta checkbox + chip
   * in sync with the tag path on the address bar.
   */
  function syncOfertaFilterFromUrl(root) {
    if (!root) return;

    var sample = root.querySelector('[data-offhoo-tag-filter]');
    if (!sample) return;

    var active = isOfertaActiveFromLocation(root);

    root.querySelectorAll('[data-offhoo-tag-filter]').forEach(function (input) {
      input.checked = active;
    });

    root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
      var existingChip = findOfertaActiveChip(form);
      var ofertaInput = form.querySelector('[data-offhoo-tag-filter]');

      if (active && !existingChip) {
        var container = ensureActiveFiltersContainer(form);
        if (!container || !ofertaInput) return;

        var link = document.createElement('a');
        link.href = ofertaInput.dataset.urlOff || window.location.pathname;
        link.className = 'offhoo-active-filter';
        link.setAttribute('data-offhoo-preserve-query', '');
        link.setAttribute('data-offhoo-oferta-clear', '');
        link.appendChild(document.createTextNode(getOfertaFilterLabel(form)));
        link.appendChild(document.createTextNode(' '));
        var closeMark = document.createElement('span');
        closeMark.setAttribute('aria-hidden', 'true');
        closeMark.textContent = '×';
        link.appendChild(closeMark);
        container.appendChild(link);
      } else if (!active && existingChip) {
        existingChip.remove();
      }
    });
  }

  function syncCatalogFilterUi(root) {
    syncSubcategoryCheckboxesFromUrl(root);
    syncSubcategoryActiveChips(root);
    syncOfertaFilterFromUrl(root);
    syncPriceFiltersFromUrl(root);
  }

  function clearSubcategorySelection(root, handle) {
    var groups = getSubcategoryGroups(root);
    if (!groups.length) return null;

    var targetHandle = (handle || '').trim();
    groups.forEach(function (group) {
      group.querySelectorAll('[data-offhoo-menu-subcategory]').forEach(function (input) {
        if ((input.dataset.handle || '').trim() === targetHandle) {
          setSubcategoryInputActive(input, false);
        }
      });
    });

    return buildSubcategoryFilterUrl(root, groups[0]);
  }

  var subcatsCatalogCache = {};
  var subcatsCatalogStates = new WeakMap();

  function updateProductCountDisplay(root, visibleCount, isFiltered) {
    if (!root) return;
    var countEl = root.querySelector('.offhoo-main-collection__count');
    if (!countEl) return;

    if (!isFiltered) {
      var original = countEl.getAttribute('data-offhoo-count-original');
      if (original != null) {
        countEl.textContent = original;
      }
      return;
    }

    if (!countEl.hasAttribute('data-offhoo-count-original')) {
      countEl.setAttribute('data-offhoo-count-original', countEl.textContent.trim());
    }

    var template = countEl.getAttribute('data-offhoo-count-template');
    if (!template) {
      var originalText = countEl.getAttribute('data-offhoo-count-original') || countEl.textContent.trim();
      template = originalText.replace(/\d[\d.,]*/g, '{{ count }}');
      countEl.setAttribute('data-offhoo-count-template', template);
    }

    countEl.textContent = template.replace('{{ count }}', String(visibleCount));
  }

  function getActiveSubcatHandles(root) {
    var group = getSubcategoryGroup(root);
    var handles = getSelectedSubcatHandles(group);
    if (!handles.length) {
      handles = readActiveSubcatHandles(root);
    }
    return handles;
  }

  function isSubcatsCatalogMode(root) {
    if (readSubcatsFromUrl(window.location).length > 1) return true;
    return getActiveSubcatHandles(root).length > 1;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function buildSubcatsCatalogCacheKey(root, handles) {
    var url = normalizeUrl(window.location.href);
    syncOfertaPathname(url, root);
    url.searchParams.delete('subcats');
    url.searchParams.delete('page');
    url.searchParams.delete('section_id');
    url.searchParams.delete('view');
    return (
      normalizePathname(url.pathname) +
      '?' +
      url.searchParams.toString() +
      '::' +
      handles.slice().sort().join('+')
    );
  }

  function formatAjaxMoneyDisplay(amount) {
    if (amount == null || amount === '') return '';
    var num = Number(amount);
    if (!isFinite(num)) return String(amount);
    return num.toFixed(2).replace('.', ',');
  }

  function mapAjaxCollectionProduct(product, sourceHandle) {
    if (!product) return null;
    var variants = product.variants || [];
    var firstVariant = variants[0] || {};
    var addVariant = null;
    for (var i = 0; i < variants.length; i += 1) {
      if (variants[i] && variants[i].available) {
        addVariant = variants[i];
        break;
      }
    }
    if (!addVariant) addVariant = firstVariant;

    var price = addVariant.price != null ? addVariant.price : product.price;
    var compareAt =
      addVariant.compare_at_price != null ? addVariant.compare_at_price : product.compare_at_price;
    var priceNum = Number(price);
    var compareNum = Number(compareAt);
    var isSale = isFinite(compareNum) && isFinite(priceNum) && compareNum > priceNum;
    var available = variants.some(function (variant) {
      return variant && variant.available;
    });
    if (!variants.length && product.available != null) {
      available = !!product.available;
    }

    var images = [];
    if (Array.isArray(product.images)) {
      product.images.forEach(function (img) {
        if (!img || !img.src) return;
        images.push({
          src: img.src,
          alt: img.alt || product.title || '',
          width: img.width || 720,
          height: img.height || 720,
        });
      });
    }
    if (!images.length && addVariant.featured_image && addVariant.featured_image.src) {
      images.push({
        src: addVariant.featured_image.src,
        alt: product.title || '',
        width: addVariant.featured_image.width || 720,
        height: addVariant.featured_image.height || 720,
      });
    }
    if (!images.length && typeof product.featured_image === 'string' && product.featured_image) {
      images.push({
        src: product.featured_image,
        alt: product.title || '',
        width: 720,
        height: 720,
      });
    }

    var image = images.length ? images[0].src : null;
    var handle = product.handle || '';
    var tags = [];
    if (Array.isArray(product.tags)) {
      tags = product.tags.map(function (tag) {
        return String(tag || '').trim();
      }).filter(Boolean);
    } else if (typeof product.tags === 'string' && product.tags) {
      tags = product.tags.split(',').map(function (tag) {
        return tag.trim();
      }).filter(Boolean);
    }

    return {
      id: product.id,
      handle: handle,
      title: product.title || '',
      url: handle ? '/products/' + encodeURIComponent(handle) : '#',
      available: available,
      variant_id: addVariant && addVariant.id != null ? addVariant.id : null,
      variants_count: variants.length,
      price: isFinite(priceNum) ? Math.round(priceNum * 100) : price,
      price_display: formatAjaxMoneyDisplay(price),
      compare_at_price: isFinite(compareNum) ? Math.round(compareNum * 100) : compareAt,
      compare_at_price_display: isSale ? formatAjaxMoneyDisplay(compareAt) : null,
      is_sale: isSale,
      image: image,
      image_alt: images.length ? images[0].alt : product.title || '',
      images: images,
      tags: tags,
      collection_handles: sourceHandle ? [sourceHandle] : [],
    };
  }

  function parseMoneyMajor(value) {
    if (value == null || value === '') return null;
    var normalized = String(value).replace(/\s/g, '').replace(',', '.');
    var num = Number(normalized);
    return isFinite(num) ? num : null;
  }

  function getActiveSortBy(root) {
    // Empty string = "Por defecto" → omit sort_by so Shopify uses each collection's admin default.
    if (root) {
      var select = root.querySelector('[data-offhoo-sort-form] select[name="sort_by"]');
      if (select) {
        return String(select.value || '').trim();
      }
    }

    return (new URLSearchParams(window.location.search).get('sort_by') || '').trim();
  }

  function syncSortByAcrossForms(root, sortBy) {
    if (!root) return;
    var value = String(sortBy || '').trim();

    root.querySelectorAll('[data-offhoo-sort-form] select[name="sort_by"]').forEach(function (select) {
      select.value = value;
    });

    root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
      var hidden = form.querySelector('input[name="sort_by"]');
      if (!value) {
        if (hidden) hidden.remove();
        return;
      }
      if (hidden) {
        hidden.value = value;
        return;
      }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'sort_by';
      input.value = value;
      form.appendChild(input);
    });
  }

  function getSubcatsCatalogContext(root) {
    var params = collectFilterQueryFromRoot(root);
    var locationParams = new URLSearchParams(window.location.search);
    locationParams.forEach(function (value, key) {
      if (key === 'sort_by') return;
      if (key.indexOf('filter.') === 0 && !params.getAll(key).includes(value)) {
        params.append(key, value);
      }
    });

    var sortBy = getActiveSortBy(root);
    syncSortByAcrossForms(root, sortBy);
    if (sortBy) {
      params.set('sort_by', sortBy);
    } else {
      params.delete('sort_by');
    }

    var priceMin = null;
    var priceMax = null;
    params.forEach(function (value, key) {
      var lower = String(key).toLowerCase();
      if (lower.indexOf('price') === -1) return;
      var amount = parseMoneyMajor(value);
      if (amount == null) return;
      if (lower.indexOf('gte') !== -1 || lower.indexOf('min') !== -1) {
        priceMin = amount;
      }
      if (lower.indexOf('lte') !== -1 || lower.indexOf('max') !== -1) {
        priceMax = amount;
      }
    });

    var ofertaTag = '';
    var ofertaChecked = getCheckedOfertaFilter(root);
    if (ofertaChecked) {
      ofertaTag = (ofertaChecked.dataset.tag || '').trim();
    }
    if (!ofertaTag) {
      var tagSample = root && root.querySelector('[data-offhoo-tag-filter]');
      var configuredTag = (tagSample && tagSample.dataset.tag) || '';
      configuredTag = configuredTag.trim();
      if (configuredTag && splitCollectionPath(window.location.pathname).tags.indexOf(configuredTag) !== -1) {
        ofertaTag = configuredTag;
      }
    }

    return {
      sortBy: sortBy,
      priceMin: priceMin,
      priceMax: priceMax,
      ofertaTag: ofertaTag,
      filterParams: params,
    };
  }

  function buildCollectionProductsJsonUrl(handle, page, limit, context) {
    context = context || {};
    // Shopify only supports /collections/{handle}/products.json — tag suffixes 404.
    // Oferta / price are applied after fetch in applySubcatsCatalogClientRules.
    var url = new URL('/collections/' + encodeURIComponent(handle) + '/products.json', window.location.origin);
    url.searchParams.set('limit', String(limit));
    url.searchParams.set('page', String(page));
    if (context.sortBy) {
      url.searchParams.set('sort_by', context.sortBy);
    }

    return url;
  }

  function applySubcatsCatalogClientRules(products, context) {
    context = context || {};
    var list = (products || []).slice();

    if (context.ofertaTag) {
      var ofertaTag = context.ofertaTag;
      list = list.filter(function (product) {
        var tags = product.tags || [];
        return tags.some(function (tag) {
          return String(tag) === ofertaTag;
        });
      });
    }

    if (context.priceMin != null || context.priceMax != null) {
      list = list.filter(function (product) {
        var major = Number(product.price) / 100;
        if (!isFinite(major)) return false;
        if (context.priceMin != null && major < context.priceMin) return false;
        if (context.priceMax != null && major > context.priceMax) return false;
        return true;
      });
    }

    var sortBy = context.sortBy || '';
    if (sortBy === 'price-ascending') {
      list.sort(function (a, b) {
        return Number(a.price) - Number(b.price);
      });
    } else if (sortBy === 'price-descending') {
      list.sort(function (a, b) {
        return Number(b.price) - Number(a.price);
      });
    } else if (sortBy === 'title-descending') {
      list.sort(function (a, b) {
        return String(b.title || '').localeCompare(String(a.title || ''), undefined, {
          sensitivity: 'base',
        });
      });
    } else if (sortBy === 'title-ascending') {
      list.sort(function (a, b) {
        return String(a.title || '').localeCompare(String(b.title || ''), undefined, {
          sensitivity: 'base',
        });
      });
    }
    // Empty / other (admin default via products.json): keep merged fetch order.

    return list;
  }

  var SUBCATS_ADD_ICON_SVG =
    '<span class="svg-wrapper add-to-cart-icon" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.608 9.421V6.906H3.392v8.016c0 .567.224 1.112.624 1.513.4.402.941.627 1.506.627H8.63M8.818 3h2.333c.618 0 1.212.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.344c0-.622.246-1.218.683-1.658A2.33 2.33 0 0 1 8.82 3"/>' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M14.608 12.563v5m2.5-2.5h-5"/>' +
    '</svg></span>';

  function getAddToCartAnimationSetting() {
    var existing = document.querySelector('add-to-cart-component[data-add-to-cart-animation]');
    if (existing && existing.getAttribute('data-add-to-cart-animation') != null) {
      return existing.getAttribute('data-add-to-cart-animation');
    }
    return 'true';
  }

  function buildSubcatsAddActionHtml(product) {
    if (!product.available) {
      return (
        '<button type="button" class="offhoo-product-card__add-icon offhoo-product-card__add-icon--disabled" disabled aria-label="Agotado">' +
        SUBCATS_ADD_ICON_SVG +
        '</button>'
      );
    }

    // Multi-variant: same as theme "choose" — go to PDP (no quick-add modal without product-card CE).
    if (product.variants_count > 1 || !product.variant_id) {
      return (
        '<a href="' +
        escapeHtml(product.url || '#') +
        '" class="button quick-add__button quick-add__button--choose add-to-cart-button" aria-label="Seleccionar">' +
        '<span class="add-to-cart-text">' +
        SUBCATS_ADD_ICON_SVG +
        '</span></a>'
      );
    }

    // Single variant: reuse theme quick-add + product-form markup for fly-to-cart + drawer morph.
    var sectionEl = document.querySelector('[data-offhoo-collection]');
    var sectionId = sectionEl && sectionEl.dataset.sectionId ? sectionEl.dataset.sectionId : '';
    var formId = 'QuickAdd-ProductForm-' + product.id + '-subcats';
    var media = product.image ? escapeHtml(product.image) : '';
    var animation = escapeHtml(getAddToCartAnimationSetting());

    return (
      '<quick-add-component class="quick-add custom-color-quick-add" data-product-title="' +
      escapeHtml(product.title || '') +
      '" data-quick-add-button="add" data-product-options-count="1">' +
      '<product-form-component class="quick-add__product-form-component" data-section-id="' +
      escapeHtml(sectionId) +
      '" data-product-id="' +
      escapeHtml(product.id) +
      '" data-product-url="' +
      escapeHtml(product.url || '') +
      '" on:submit="/handleSubmit">' +
      '<div class="visually-hidden" aria-live="assertive" role="status" aria-atomic="true" ref="liveRegion"></div>' +
      '<form method="post" action="/cart/add" id="' +
      escapeHtml(formId) +
      '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">' +
      '<input type="hidden" name="form_type" value="product">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="id" ref="variantId" value="' +
      escapeHtml(product.variant_id) +
      '">' +
      '<input type="hidden" name="quantity" value="1">' +
      '<add-to-cart-component ref="addToCartButtonContainer" data-product-variant-media="' +
      media +
      '" data-add-to-cart-animation="' +
      animation +
      '">' +
      '<button type="submit" name="add" ref="addToCartButton" on:click="/handleClick" class="button quick-add__button quick-add__button--add add-to-cart-button" aria-label="Agregar">' +
      '<span class="add-to-cart-text">' +
      SUBCATS_ADD_ICON_SVG +
      '<span class="add-to-cart-text__content is-visually-hidden-mobile"><span><span>Agregar</span></span></span>' +
      '</span>' +
      '<span class="add-to-cart__added"><span class="svg-wrapper add-to-cart__added-icon" aria-hidden="true"></span></span>' +
      '</button></add-to-cart-component></form></product-form-component></quick-add-component>'
    );
  }

  function buildSubcatsProductCardHtml(product, index, currencySymbol) {
    var symbol = currencySymbol || '€';
    var title = escapeHtml(product.title || '');
    var url = escapeHtml(product.url || '#');
    var priceDisplay = escapeHtml(product.price_display || '');
    var compareDisplay = product.compare_at_price_display
      ? escapeHtml(product.compare_at_price_display)
      : '';
    var handles = Array.isArray(product.collection_handles)
      ? product.collection_handles.join(',')
      : '';
    var mediaItems = Array.isArray(product.images) ? product.images.filter(function (item) {
      return item && item.src;
    }) : [];
    var primary = mediaItems[0];
    var imageHtml = primary
      ? '<img src="' +
        escapeHtml(primary.src) +
        '" alt="' +
        escapeHtml(primary.alt || product.title || '') +
        '" width="' +
        escapeHtml(primary.width || 720) +
        '" height="' +
        escapeHtml(primary.height || 720) +
        '" loading="lazy" sizes="(min-width: 990px) 25vw, 50vw" class="offhoo-product-card__image is-active" data-offhoo-product-card-image data-media-index="0">'
      : '';

    var mediaTemplateHtml = '';
    var mediaControlsHtml = '';
    if (mediaItems.length > 1) {
      // Escape < so titles/alts cannot break out of the <template> when parsed as HTML.
      var mediaJson = JSON.stringify(mediaItems).replace(/</g, '\\u003c');
      mediaTemplateHtml = '<template data-offhoo-product-card-media>' + mediaJson + '</template>';
      mediaControlsHtml =
        '<div class="offhoo-product-card__media-controls">' +
        '<button type="button" class="offhoo-product-card__media-control offhoo-product-card__media-control--previous" data-offhoo-product-card-media-control="previous" aria-label="Anterior">' +
        '<span aria-hidden="true">‹</span></button>' +
        '<button type="button" class="offhoo-product-card__media-control offhoo-product-card__media-control--next" data-offhoo-product-card-media-control="next" aria-label="Siguiente">' +
        '<span aria-hidden="true">›</span></button>' +
        '</div>';
    }

    var badges = '';
    if (!product.available) {
      badges += '<span class="offhoo-badge offhoo-badge--muted">Agotado</span>';
    } else if (product.is_sale) {
      badges += '<span class="offhoo-badge offhoo-badge--sale">Oferta</span>';
    }

    var compareHtml = '';
    if (product.is_sale && compareDisplay) {
      compareHtml =
        '<s class="offhoo-product-card__price-compare"><span aria-hidden="true">' +
        compareDisplay +
        ' ' +
        escapeHtml(symbol) +
        '</span></s>';
    }

    return (
      '<li data-offhoo-product-item data-offhoo-product-id="' +
      escapeHtml(product.id) +
      '" data-offhoo-collection-handles="' +
      escapeHtml(handles) +
      '">' +
      '<article class="offhoo-product-card" data-product-id="' +
      escapeHtml(product.id) +
      '" data-offhoo-track-product data-offhoo-track-product-id="' +
      escapeHtml(product.id) +
      '" data-offhoo-track-product-index="' +
      escapeHtml(index) +
      '" data-offhoo-track-product-price="' +
      escapeHtml(product.price) +
      '" data-offhoo-track-product-name="' +
      title +
      '" data-offhoo-track-product-url="' +
      url +
      '">' +
      '<div class="offhoo-product-card__media" data-offhoo-product-card-media-wrapper data-media-index="0">' +
      '<a href="' +
      url +
      '" class="offhoo-product-card__image-link" aria-label="' +
      title +
      '" data-offhoo-track-click="product">' +
      imageHtml +
      '</a>' +
      mediaTemplateHtml +
      '<div class="offhoo-product-card__badges">' +
      badges +
      '</div>' +
      '<div class="offhoo-product-card__overlay" aria-hidden="false">' +
      mediaControlsHtml +
      '<div class="offhoo-product-card__actions" data-offhoo-track-click="add_cart">' +
      buildSubcatsAddActionHtml(product) +
      '</div></div></div>' +
      '<div class="offhoo-product-card__body">' +
      '<a href="' +
      url +
      '" class="offhoo-product-card__title" data-offhoo-track-click="product">' +
      title +
      '</a>' +
      '<div class="offhoo-product-card__meta-row">' +
      '<div class="offhoo-product-card__price" style="flex: 1 1 0;">' +
      '<span class="offhoo-product-card__price-current"><span aria-hidden="true">' +
      priceDisplay +
      ' ' +
      escapeHtml(symbol) +
      '</span></span>' +
      compareHtml +
      '</div></div></div></article></li>'
    );
  }

  function ensureSubcatsResultsShell(root) {
    var results = root.querySelector('.offhoo-main-collection__results');
    if (!results) return null;

    var grid = results.querySelector('[data-offhoo-product-grid]');
    if (!grid) {
      grid = document.createElement('ul');
      grid.id = 'ResultsList';
      grid.className = 'offhoo-main-collection__grid';
      grid.setAttribute('role', 'list');
      grid.setAttribute('data-offhoo-product-grid', '');
      results.appendChild(grid);
    }

    var empty = results.querySelector('[data-offhoo-filter-empty]');
    if (!empty) {
      empty = document.createElement('div');
      empty.className = 'offhoo-main-collection__empty';
      empty.setAttribute('data-offhoo-filter-empty', '');
      empty.hidden = true;
      empty.innerHTML =
        '<h2>' +
        escapeHtml(root.dataset.offhooEmptyTitle || 'No encontramos productos') +
        '</h2><p>' +
        escapeHtml(root.dataset.offhooEmptyText || '') +
        '</p>';
      var buttonLabel = (root.dataset.offhooEmptyButtonLabel || '').trim();
      var buttonLink = (root.dataset.offhooEmptyButtonLink || '').trim();
      if (buttonLabel && buttonLink) {
        empty.innerHTML +=
          '<a href="' + escapeHtml(buttonLink) + '">' + escapeHtml(buttonLabel) + '</a>';
      }
      results.appendChild(empty);
    }

    return { results: results, grid: grid, empty: empty };
  }

  function setSubcatsEmptyVisible(emptyEl, visible) {
    if (!emptyEl) return;
    emptyEl.hidden = !visible;
    if (visible) {
      emptyEl.style.removeProperty('display');
    } else {
      emptyEl.style.display = 'none';
    }
  }

  function hideAllSubcatsEmptyStates(root) {
    if (!root) return;
    root.querySelectorAll('.offhoo-main-collection__empty').forEach(function (el) {
      setSubcatsEmptyVisible(el, false);
    });
  }

  function renderSubcatsCatalogPage(root, state, append) {
    var shell = ensureSubcatsResultsShell(root);
    if (!shell) return;

    var pageSize = state.pageSize;
    var start = (state.page - 1) * pageSize;
    var slice = state.filtered.slice(start, start + pageSize);
    var currencySymbol = state.currencySymbol || '€';

    if (!append) {
      shell.grid.innerHTML = '';
    }

    if (!state.filtered.length) {
      shell.grid.hidden = true;
      hideAllSubcatsEmptyStates(root);
      setSubcatsEmptyVisible(shell.empty, true);
      updateProductCountDisplay(root, 0, true);
      return;
    }

    hideAllSubcatsEmptyStates(root);
    setSubcatsEmptyVisible(shell.empty, false);
    shell.grid.hidden = false;

    var html = slice
      .map(function (product, index) {
        return buildSubcatsProductCardHtml(product, start + index + 1, currencySymbol);
      })
      .join('');
    shell.grid.insertAdjacentHTML('beforeend', html);
    updateProductCountDisplay(root, state.filtered.length, true);
  }

  function cleanupSubcatsCatalogScroll(root) {
    var state = subcatsCatalogStates.get(root);
    if (!state || !state.onScroll) return;
    var scrollRoot = state.scrollRoot || window;
    scrollRoot.removeEventListener('scroll', state.onScroll);
    state.onScroll = null;
    state.scrollRoot = null;
  }

  function initSubcatsCatalogScroll(root, state) {
    cleanupSubcatsCatalogScroll(root);

    var offset = 400;
    var sentinel = root.querySelector('[data-offhoo-infinite-scroll]');
    if (sentinel && sentinel.dataset.offset) {
      offset = parseInt(sentinel.dataset.offset, 10) || offset;
    }

    var scrollRoot = getScrollRoot();
    state.scrollRoot = scrollRoot;

    state.onScroll = function () {
      if (!root.isConnected || state.loadingMore) return;
      if (state.page * state.pageSize >= state.filtered.length) return;
      if (getDistanceFromBottom(scrollRoot) > offset) return;

      state.loadingMore = true;
      state.page += 1;
      renderSubcatsCatalogPage(root, state, true);
      state.loadingMore = false;
    };

    scrollRoot.addEventListener('scroll', state.onScroll, { passive: true });
    // In case first page already fills the viewport, try loading more once.
    state.onScroll();
  }

  function detectCurrencySymbol(root) {
    var fromDataset = (root && root.dataset.offhooCurrencySymbol) || '';
    if (fromDataset) return fromDataset;
    var priceEl = root && root.querySelector('.offhoo-product-card__price-current');
    var text = priceEl ? priceEl.textContent || '' : '';
    var match = text.match(/[^\d\s.,-]+/);
    return (match && match[0].trim()) || '€';
  }

  function fetchCollectionProductsAjax(handle, context) {
    var products = [];
    var page = 1;
    var limit = 250;
    var maxPages = 40;

    function loadPage() {
      var url = buildCollectionProductsJsonUrl(handle, page, limit, context);
      return fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) throw new Error('products-json-' + response.status);
          return response.json();
        })
        .then(function (data) {
          var batch = (data && data.products) || [];
          batch.forEach(function (product) {
            var mapped = mapAjaxCollectionProduct(product, handle);
            if (mapped) products.push(mapped);
          });
          if (batch.length >= limit && page < maxPages) {
            page += 1;
            return loadPage();
          }
          return products;
        });
    }

    return loadPage();
  }

  // Multi-select: union products from each selected L3 collection (Ajax products.json).
  function fetchAllSubcatsCatalogProducts(root, handles) {
    var currencySymbol = detectCurrencySymbol(root);
    var context = getSubcatsCatalogContext(root);
    var uniqueHandles = [];
    var seenHandle = {};
    (handles || []).forEach(function (handle) {
      var key = String(handle || '').trim();
      if (!key || seenHandle[key]) return;
      seenHandle[key] = true;
      uniqueHandles.push(key);
    });

    if (!uniqueHandles.length) {
      return Promise.resolve({ products: [], filtered: [], currencySymbol: currencySymbol });
    }

    return Promise.all(
      uniqueHandles.map(function (handle) {
        return fetchCollectionProductsAjax(handle, context);
      })
    ).then(function (groups) {
      var merged = [];
      var seenId = {};
      groups.forEach(function (group) {
        (group || []).forEach(function (product) {
          var id = String(product.id);
          if (seenId[id]) {
            var existing = seenId[id];
            var extra = product.collection_handles || [];
            extra.forEach(function (h) {
              if (existing.collection_handles.indexOf(h) === -1) {
                existing.collection_handles.push(h);
              }
            });
            var extraTags = product.tags || [];
            extraTags.forEach(function (tag) {
              if (existing.tags.indexOf(tag) === -1) existing.tags.push(tag);
            });
            return;
          }
          seenId[id] = product;
          merged.push(product);
        });
      });

      var filtered = applySubcatsCatalogClientRules(merged, context);
      return {
        products: merged,
        filtered: filtered,
        currencySymbol: currencySymbol,
      };
    });
  }

  function stopSubcatsCatalogMode(root) {
    if (!root) return;
    cleanupSubcatsCatalogScroll(root);
    subcatsCatalogStates.delete(root);
    root.classList.remove('is-subcats-catalog-mode');
    delete root.dataset.offhooSubcatsCatalogKey;
  }

  function shouldCacheSubcatsCatalog(context) {
    if (!context) return true;
    // Do not cache when explicit sort / price / Oferta are active — always refetch.
    if (context.sortBy) return false;
    if (context.priceMin != null || context.priceMax != null) return false;
    if (context.ofertaTag) return false;
    var filterParams = context.filterParams;
    if (filterParams && typeof filterParams.forEach === 'function') {
      var hasFilter = false;
      filterParams.forEach(function (_value, key) {
        if (key && String(key).indexOf('filter.') === 0) hasFilter = true;
      });
      if (hasFilter) return false;
    }
    return true;
  }

  function startSubcatsCatalogMode(root) {
    if (!root) return Promise.resolve();

    var handles = getActiveSubcatHandles(root);
    if (handles.length <= 1 && readSubcatsFromUrl(window.location).length <= 1) {
      stopSubcatsCatalogMode(root);
      updateProductCountDisplay(root, 0, false);
      return Promise.resolve();
    }

    cleanupInfiniteScroll(root);
    cleanupSubcatsCatalogScroll(root);

    var pageSize = parseInt(root.dataset.offhooProductsPerPage, 10) || 24;
    var catalogContext = getSubcatsCatalogContext(root);
    var cacheKey = buildSubcatsCatalogCacheKey(root, handles);
    var useCache = shouldCacheSubcatsCatalog(catalogContext);
    root.classList.add('is-subcats-catalog-mode');
    root.dataset.offhooSubcatsCatalogKey = cacheKey;
    setLoading(root, true);

    // Clear stale grid immediately so prior L2/L3 section HTML does not flash.
    var loadingShell = ensureSubcatsResultsShell(root);
    if (loadingShell) {
      loadingShell.grid.innerHTML = '';
      loadingShell.grid.hidden = false;
      hideAllSubcatsEmptyStates(root);
      setSubcatsEmptyVisible(loadingShell.empty, false);
    }

    var cached = useCache ? subcatsCatalogCache[cacheKey] : null;
    var loadPromise = cached
      ? Promise.resolve(cached)
      : fetchAllSubcatsCatalogProducts(root, handles).then(function (payload) {
          if (useCache) {
            subcatsCatalogCache[cacheKey] = payload;
          }
          return payload;
        });

    return loadPromise
      .then(function (payload) {
        if (!root.isConnected) return;
        if (root.dataset.offhooSubcatsCatalogKey !== cacheKey) return;

        var state = {
          handles: handles,
          filtered: payload.filtered,
          currencySymbol: payload.currencySymbol,
          page: 1,
          pageSize: pageSize,
          loadingMore: false,
          onScroll: null,
        };
        subcatsCatalogStates.set(root, state);
        renderSubcatsCatalogPage(root, state, false);
        initSubcatsCatalogScroll(root, state);

        hideAllSubcatsEmptyStates(root);
        if (!state.filtered.length) {
          var shell = ensureSubcatsResultsShell(root);
          if (shell) setSubcatsEmptyVisible(shell.empty, true);
        }
        var sentinel = root.querySelector('[data-offhoo-infinite-scroll]');
        if (sentinel) {
          sentinel.hidden = true;
          sentinel.style.display = 'none';
        }
      })
      .catch(function (error) {
        console.warn('[offhoo-collection] subcats catalog failed', error);
      })
      .then(function () {
        setLoading(root, false);
      });
  }

  function buildSubcategoryFilterUrl(root, group) {
    var handles = getSelectedSubcatHandles(group);
    var parentUrl = (group && group.dataset.parentUrl) || '';
    var url;

    if (!handles.length) {
      url = normalizeUrl(parentUrl || window.location.href);
      url.searchParams.delete('subcats');
    } else if (handles.length === 1) {
      // Single selection: keep deep-link to that L3 collection.
      var single = null;
      var singleHandle = handles[0];
      group.querySelectorAll('[data-offhoo-menu-subcategory]').forEach(function (input) {
        if (!single && (input.dataset.handle || '').trim() === singleHandle) {
          single = input;
        }
      });
      url = normalizeUrl((single && single.dataset.urlOn) || parentUrl || window.location.href);
      url.searchParams.delete('subcats');
    } else {
      // Multi selection: stay on L2 parent and filter by collection membership.
      url = normalizeUrl(parentUrl || window.location.href);
      url.searchParams.set('subcats', handles.join('+'));
    }

    var merged = collectFilterQueryFromRoot(root);
    url.searchParams.delete('sort_by');
    merged.forEach(function (value, key) {
      if (key === 'subcats') return;
      if (key === 'sort_by') {
        if (value) url.searchParams.set(key, value);
        return;
      }
      if (key.indexOf('filter.') === 0) {
        if (!url.searchParams.getAll(key).includes(value)) {
          url.searchParams.append(key, value);
        }
      }
    });

    // Preserve Oferta tag path when present.
    syncOfertaPathname(url, root);
    url.searchParams.delete('section_id');
    url.searchParams.delete('page');
    url.searchParams.delete('filter.p.tag');
    return url;
  }

  function splitCollectionPath(pathname) {
    var parts = normalizePathname(pathname || '')
      .split('/')
      .filter(Boolean);
    if (parts.length < 2 || parts[0].toLowerCase() !== 'collections') {
      return { handle: '', tags: [] };
    }

    var handle = parts[1];
    try {
      handle = decodeURIComponent(handle);
    } catch (error) {
      // keep raw handle
    }

    var tags = [];
    if (parts.length > 2) {
      tags = parts
        .slice(2)
        .join('/')
        .split('+')
        .map(function (tag) {
          try {
            return decodeURIComponent(tag);
          } catch (error) {
            return tag;
          }
        })
        .filter(Boolean);
    }

    return { handle: handle, tags: tags };
  }

  function buildCollectionPath(handle, tags) {
    var path = '/collections/' + handle;
    if (tags && tags.length) {
      path += '/' + tags.join('+');
    }
    return normalizePathname(path);
  }

  /**
   * Oferta uses collection tag paths (not form fields). Apply/remove the tag on
   * the *target* collection handle — never replace the whole pathname with the
   * checkbox's urlOn (that is bound to whatever collection rendered the form).
   */
  function syncOfertaPathname(url, root) {
    var checked = getCheckedOfertaFilter(root);
    var any = (root || document).querySelector('[data-offhoo-tag-filter]');
    var ofertaTag = ((checked && checked.dataset.tag) || (any && any.dataset.tag) || '').trim();
    if (!ofertaTag) return url;

    var parsed = splitCollectionPath(url.pathname);
    if (!parsed.handle) return url;

    var tags = parsed.tags.slice();
    var hasOferta = tags.indexOf(ofertaTag) !== -1;

    if (checked) {
      if (!hasOferta) tags.push(ofertaTag);
      url.pathname = buildCollectionPath(parsed.handle, tags);
      return url;
    }

    if (hasOferta) {
      tags = tags.filter(function (tag) {
        return tag !== ofertaTag;
      });
      url.pathname = buildCollectionPath(parsed.handle, tags);
    }

    return url;
  }

  /**
   * Read active sort/filter query from filter forms only (price lives here).
   * Skip [data-offhoo-sort-form] filter.* hiddens — they are Liquid snapshots and go stale.
   */
  function collectFilterQueryFromRoot(root) {
    var params = new URLSearchParams();
    if (!root) return params;

    root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
      var formData = new FormData(form);
      formData.forEach(function (value, key) {
        if (value === null || value === undefined || value === '') return;
        // sort_by is resolved separately via getActiveSortBy (select wins over stale hidden).
        if (key === 'sort_by') return;
        if (key.indexOf('filter.') !== 0) return;
        if (!params.getAll(key).includes(String(value))) {
          params.append(key, String(value));
        }
      });
    });

    var sortBy = getActiveSortBy(root);
    if (sortBy) params.set('sort_by', sortBy);

    return params;
  }

  function buildSectionRenderUrl(pageUrl, sectionId) {
    var url = normalizeUrl(pageUrl);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', sectionId);
    return url;
  }

  function buildPublicUrl(pageUrl) {
    var url = normalizeUrl(pageUrl);
    url.searchParams.delete('section_id');
    url.searchParams.delete('page');
    return url;
  }

  function urlFromForm(form, root) {
    root = root || getCollectionRoot(form);
    var action = form.getAttribute('action') || window.location.pathname;
    var url = normalizeUrl(new URL(action, window.location.origin));
    var params = new URLSearchParams();
    var formData = new FormData(form);

    formData.forEach(function (value, key) {
      if (value === null || value === undefined) return;
      if (key === 'sort_by') return;
      params.append(key, String(value));
    });

    var sortBy = getActiveSortBy(root);
    if (sortBy) {
      params.set('sort_by', sortBy);
    } else {
      params.delete('sort_by');
    }

    url.search = params.toString();
    syncOfertaPathname(url, root);
    syncSubcatsQuery(url, root);
    return url;
  }

  function setLoading(root, isLoading) {
    if (!root) return;
    root.classList.toggle('is-loading', Boolean(isLoading));
    root.setAttribute('aria-busy', isLoading ? 'true' : 'false');
  }

  function unlockPageScroll() {
    document.documentElement.classList.remove('offhoo-filter-drawer-open');
  }

  function closeDrawer(root) {
    var drawer = root && root.querySelector('[data-offhoo-filter-drawer]');
    if (drawer) {
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
    }
    unlockPageScroll();

    if (drawerLastTrigger && typeof drawerLastTrigger.focus === 'function') {
      drawerLastTrigger.focus();
      drawerLastTrigger = null;
    }
  }

  function openDrawer(root) {
    var drawer = root && root.querySelector('[data-offhoo-filter-drawer]');
    if (!drawer) return;

    drawerLastTrigger = document.activeElement;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('offhoo-filter-drawer-open');

    var focusable = getFocusable(drawer);
    if (focusable.length > 0) {
      focusable[0].focus();
    }
  }

  function cleanupInfiniteScroll(root) {
    var cleanup = infiniteScrollCleanups.get(root);
    if (typeof cleanup === 'function') {
      cleanup();
      infiniteScrollCleanups.delete(root);
    }
  }

  function removePriceInputs(form) {
    if (!form) return;
    form.querySelectorAll('[data-offhoo-price-value]').forEach(function (input) {
      input.remove();
    });
  }

  function removePriceActiveChips(form) {
    if (!form) return;
    form.querySelectorAll('[data-offhoo-price-clear]').forEach(function (chip) {
      chip.remove();
    });
  }

  function isPriceFilterParamName(name) {
    var key = String(name || '').toLowerCase();
    return key.indexOf('filter.') === 0 && key.indexOf('price') !== -1;
  }

  /** Clear price on every filter form (desktop + drawer) and stale sort-form hiddens. */
  function clearPriceFiltersOnRoot(root) {
    if (!root) return;

    root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
      form.querySelectorAll('[data-offhoo-price-range]').forEach(function (checkbox) {
        checkbox.checked = false;
      });
      removePriceInputs(form);
      removePriceActiveChips(form);
    });

    // Sort form may still hold Liquid price hiddens from an earlier section render.
    root.querySelectorAll('[data-offhoo-sort-form] input[type="hidden"]').forEach(function (input) {
      if (isPriceFilterParamName(input.name)) input.remove();
    });
  }

  function addPriceInput(form, name, value, bound) {
    if (!name || value === undefined || value === null || value === '') return;

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.dataset.offhooPriceValue = 'true';
    input.dataset.offhooPriceBound = bound;
    form.appendChild(input);
  }

  function normalizePriceNumber(value) {
    if (value == null || value === '') return null;
    var n = Number(String(value).replace(',', '.').replace(/\s/g, ''));
    return Number.isFinite(n) ? n : null;
  }

  function priceRangeMatches(gte, lte, minRaw, maxRaw) {
    if (gte == null && lte == null) return false;
    var min = minRaw === '' || minRaw == null ? null : normalizePriceNumber(minRaw);
    var max = maxRaw === '' || maxRaw == null ? null : normalizePriceNumber(maxRaw);
    var minOk = gte == null ? min == null : min != null && gte === min;
    var maxOk = lte == null ? max == null : max != null && lte === max;
    return minOk && maxOk;
  }

  function getPriceFilterLabel(form) {
    var summary = form && form.querySelector('.offhoo-price-filter');
    if (summary) {
      var group = summary.closest('.offhoo-filter-group');
      var label = group && group.querySelector('summary span');
      if (label && label.textContent) return label.textContent.trim();
    }
    return 'Price';
  }

  function ensurePriceActiveChip(form) {
    if (!form || form.querySelector('[data-offhoo-price-clear]')) return;
    var container = ensureActiveFiltersContainer(form);
    if (!container) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'offhoo-active-filter';
    button.setAttribute('data-offhoo-price-clear', '');
    button.appendChild(document.createTextNode(getPriceFilterLabel(form)));
    button.appendChild(document.createTextNode(' '));
    var closeMark = document.createElement('span');
    closeMark.setAttribute('aria-hidden', 'true');
    closeMark.textContent = '×';
    button.appendChild(closeMark);
    container.appendChild(button);
  }

  function syncPriceFiltersFromUrl(root) {
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var sample = root.querySelector('[data-offhoo-price-range]');
    var minName = (sample && sample.dataset.priceMinName) || 'filter.v.price.gte';
    var maxName = (sample && sample.dataset.priceMaxName) || 'filter.v.price.lte';
    var gte = normalizePriceNumber(params.get(minName));
    var lte = normalizePriceNumber(params.get(maxName));
    var hasPrice = gte != null || lte != null;

    // Address bar can lag behind the section fetch URL when pushState was skipped.
    // Keep chips only when a filter form still holds price; otherwise remove them.
    if (!hasPrice) {
      root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
        var hasFormPrice =
          form.querySelector('[data-offhoo-price-value]') ||
          form.querySelector('[data-offhoo-price-range]:checked');
        if (hasFormPrice) {
          ensurePriceActiveChip(form);
        } else {
          removePriceActiveChips(form);
        }
      });
      return;
    }

    root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
      var matched = null;
      form.querySelectorAll('[data-offhoo-price-range]').forEach(function (input) {
        var isMatch = priceRangeMatches(gte, lte, input.dataset.priceMin, input.dataset.priceMax);
        input.checked = isMatch;
        if (isMatch) matched = input;
      });

      removePriceInputs(form);
      if (matched) {
        addPriceInput(form, matched.dataset.priceMinName, matched.dataset.priceMin, 'min');
        addPriceInput(form, matched.dataset.priceMaxName, matched.dataset.priceMax, 'max');
      } else {
        if (gte != null) addPriceInput(form, minName, String(gte), 'min');
        if (lte != null) addPriceInput(form, maxName, String(lte), 'max');
      }

      ensurePriceActiveChip(form);
    });
  }

  function fetchAndReplace(root, pageUrl, options) {
    options = options || {};
    var shouldCloseDrawer = options.closeDrawer !== false;
    var shouldPushState = options.pushState === true;
    root = root || getActiveCollectionRoot();
    var sectionId = getSectionId(root);

    if (!root || !sectionId) {
      console.warn('[offhoo-collection] Missing collection root or section id');
      unlockPageScroll();
      return Promise.resolve();
    }

    var publicUrl = buildPublicUrl(pageUrl);
    var renderUrl = buildSectionRenderUrl(publicUrl, sectionId);

    if (activeAbortController) {
      activeAbortController.abort();
    }

    activeAbortController = new AbortController();
    var signal = activeAbortController.signal;

    setLoading(root, true);

    return fetch(renderUrl.toString(), {
      credentials: 'same-origin',
      signal: signal,
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          var httpError = new Error('http-' + response.status);
          httpError.code = 'http';
          throw httpError;
        }
        return response.text();
      })
      .then(function (html) {
        if (signal.aborted) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incomingSection = findIncomingSection(doc, sectionId);
        var incomingRoot = doc.querySelector('[data-offhoo-collection]');
        // Always re-query live section — do not reuse a stale node from request start.
        var sectionEl = getShopifySectionEl(sectionId, getActiveCollectionRoot());

        if (!sectionEl || (!incomingSection && !incomingRoot)) {
          var missingError = new Error('missing-section');
          missingError.code = 'missing-section';
          throw missingError;
        }

        var liveRoot = sectionEl.querySelector('[data-offhoo-collection]') || getActiveCollectionRoot();
        if (liveRoot) {
          cleanupInfiniteScroll(liveRoot);
        }
        unlockPageScroll();

        try {
          if (incomingSection) {
            var nextSection = stripScripts(document.importNode(incomingSection, true));
            sectionEl.replaceWith(nextSection);
          } else {
            var currentRoot = sectionEl.querySelector('[data-offhoo-collection]');
            var nextRootNode = stripScripts(document.importNode(incomingRoot, true));
            if (currentRoot) {
              currentRoot.replaceWith(nextRootNode);
            } else {
              sectionEl.replaceChildren(nextRootNode);
            }
          }
        } catch (replaceError) {
          replaceError.code = 'replace';
          throw replaceError;
        }

        if (shouldPushState) {
          history.pushState({ offhooCollection: true }, '', publicUrl.toString());
        }

        var replacedSection = getShopifySectionEl(sectionId, null) || sectionEl;
        var nextRoot =
          (replacedSection && replacedSection.querySelector('[data-offhoo-collection]')) ||
          getActiveCollectionRoot();

        if (shouldCloseDrawer && nextRoot) {
          closeDrawer(nextRoot);
        }

        try {
          initCollectionUi(nextRoot);
        } catch (initError) {
          console.warn('[offhoo-collection] init after replace failed', initError);
        }

        // Keep document title in sync when switching collections via chips.
        var nextTitle = doc.querySelector('title');
        var nextHeading = nextRoot && nextRoot.querySelector('.offhoo-main-collection__header h1');
        if (nextTitle && nextTitle.textContent) {
          document.title = nextTitle.textContent;
        } else if (nextHeading && nextHeading.textContent) {
          document.title = nextHeading.textContent.trim();
        }
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') return;

        var liveRoot = getActiveCollectionRoot() || root;
        setLoading(liveRoot, false);
        unlockPageScroll();
        console.warn('[offhoo-collection] async update failed', error);

        // Category navigation is a real destination — fall back to full load on failure.
        if (shouldPushState) {
          window.location.href = publicUrl.toString();
        }
      })
      .finally(function () {
        if (activeAbortController && activeAbortController.signal === signal) {
          activeAbortController = null;
        }
      });
  }

  function navigatePreservingQuery(root, pathname, options) {
    var next = normalizeUrl(window.location.origin + pathname);
    next.pathname = normalizePathname(pathname);

    // Keep price/sort from forms — address bar may be stale (we don't pushState).
    var merged = collectFilterQueryFromRoot(root);
    var activeSortBy = getActiveSortBy(root);
    var locationParams = new URLSearchParams(window.location.search);
    locationParams.forEach(function (value, key) {
      if (key === 'section_id' || key === 'page' || key === 'filter.p.tag') return;
      // Default sort omits sort_by — do not rehydrate a stale location value.
      if (key === 'sort_by') {
        if (!activeSortBy) return;
        if (!merged.has(key)) merged.set(key, value);
        return;
      }
      if (key.indexOf('filter.') === 0) {
        if (!merged.has(key)) merged.set(key, value);
        return;
      }
      if (!merged.has(key)) merged.set(key, value);
    });

    next.search = merged.toString();
    if (!activeSortBy) next.searchParams.delete('sort_by');
    next.searchParams.delete('filter.p.tag');
    next.searchParams.delete('page');
    next.searchParams.delete('section_id');
    syncSubcatsQuery(next, root);

    // Multi-select catalog: avoid full section reload; refresh Ajax union in place.
    options = options || {};
    if (isSubcatsCatalogMode(root) && readSubcatsFromUrl(next).length > 1) {
      if (options.pushState !== false) {
        history.pushState({ offhooCollection: true }, '', next.toString());
      } else {
        history.replaceState({ offhooCollection: true }, '', next.toString());
      }
      if (options.closeDrawer !== false) closeDrawer(root);
      syncCatalogFilterUi(root);
      return startSubcatsCatalogMode(root);
    }

    // Keep address bar in sync with the section we just fetched (price/sort/filters).
    if (options.pushState === undefined) {
      options = Object.assign({}, options, { pushState: true });
    }
    return fetchAndReplace(root, next, options);
  }

  function updateCatalogOrReplace(root, pageUrl, options) {
    options = options || {};
    var url = normalizeUrl(pageUrl);
    syncSubcatsQuery(url, root);
    syncOfertaPathname(url, root);
    url.searchParams.delete('section_id');
    url.searchParams.delete('page');

    if (isSubcatsCatalogMode(root) || readSubcatsFromUrl(url).length > 1) {
      if (options.pushState !== false) {
        history.pushState({ offhooCollection: true }, '', url.toString());
      }
      if (options.closeDrawer !== false) closeDrawer(root);
      syncCatalogFilterUi(root);
      return startSubcatsCatalogMode(root);
    }

    // Keep address bar in sync with the section we just fetched (price/sort/filters).
    if (options.pushState === undefined) {
      options = Object.assign({}, options, { pushState: true });
    }
    return fetchAndReplace(root, url, options);
  }

  function handleLegacyTagRedirect(root) {
    if (!root) return;

    root.querySelectorAll('[data-offhoo-tag-filter]').forEach(function (checkbox) {
      var legacyTag = new URLSearchParams(window.location.search).get('filter.p.tag');
      if (legacyTag && legacyTag === checkbox.dataset.tag && !checkbox.checked && checkbox.dataset.urlOn) {
        navigatePreservingQuery(root, new URL(checkbox.dataset.urlOn, window.location.origin).pathname, {
          closeDrawer: true,
        });
      }
    });
  }

  function initCollectionUi(root) {
    if (!root) return;
    syncCatalogFilterUi(root);

    if (isSubcatsCatalogMode(root)) {
      startSubcatsCatalogMode(root);
      handleLegacyTagRedirect(root);
      return;
    }

    stopSubcatsCatalogMode(root);
    updateProductCountDisplay(root, 0, false);
    cleanupInfiniteScroll(root);
    initInfiniteScroll(root);
    handleLegacyTagRedirect(root);
  }

  function bindDelegatedEvents() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('[data-offhoo-sort-form], .offhoo-collection-filters')) return;

      var root = getCollectionRoot(form);
      if (!root) return;

      event.preventDefault();
      updateCatalogOrReplace(root, urlFromForm(form, root), { closeDrawer: true });
    });

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;

      var root = getCollectionRoot(target);
      if (!root) return;

      if (target.matches('[data-offhoo-sort-form] select')) {
        if (!target.form) return;
        syncSortByAcrossForms(root, target.value);
        updateCatalogOrReplace(root, urlFromForm(target.form, root), { closeDrawer: false });
        return;
      }

      if (target.matches('[data-offhoo-price-range]')) {
        var priceForm = target.form;
        if (!priceForm) return;

        // Read before clear — clearPriceFiltersOnRoot also unchecks `target`.
        var priceChecked = target.checked;
        var priceMin = target.dataset.priceMin;
        var priceMax = target.dataset.priceMax;
        var priceMinName = target.dataset.priceMinName;
        var priceMaxName = target.dataset.priceMaxName;

        // Desktop + drawer both hold price state — clear/apply on every filter form.
        clearPriceFiltersOnRoot(root);

        if (priceChecked) {
          root.querySelectorAll('.offhoo-collection-filters').forEach(function (form) {
            form.querySelectorAll('[data-offhoo-price-range]').forEach(function (rangeInput) {
              var sameRange =
                rangeInput.dataset.priceMin === priceMin && rangeInput.dataset.priceMax === priceMax;
              rangeInput.checked = sameRange;
            });
            addPriceInput(form, priceMinName, priceMin, 'min');
            addPriceInput(form, priceMaxName, priceMax, 'max');
          });
        }

        // Keep Oferta tag path even when form.action is still the untagged collection URL.
        syncSortByAcrossForms(root, getActiveSortBy(root));
        updateCatalogOrReplace(root, urlFromForm(priceForm, root), { closeDrawer: true });
        return;
      }

      if (target.matches('[data-offhoo-filter-auto-submit]')) {
        if (!target.form) return;
        updateCatalogOrReplace(root, urlFromForm(target.form, root), { closeDrawer: true });
        return;
      }

      if (target.matches('[data-offhoo-tag-filter]')) {
        var tagTarget = target.checked ? target.dataset.urlOn : target.dataset.urlOff;
        if (!tagTarget) return;
        navigatePreservingQuery(root, new URL(tagTarget, window.location.origin).pathname, {
          closeDrawer: true,
        });
        return;
      }

      if (target.matches('[data-offhoo-menu-subcategory]')) {
        var subcategoryGroup =
          target.closest('[data-offhoo-menu-subcategory-group]') ||
          target.closest('.offhoo-filter-group--menu-subcategory');
        if (!subcategoryGroup) return;

        // Keep desktop + drawer checkbox state in sync for multi-select.
        var changedHandle = (target.dataset.handle || '').trim();
        var isChecked = target.checked;
        getSubcategoryGroups(root).forEach(function (group) {
          group.querySelectorAll('[data-offhoo-menu-subcategory]').forEach(function (input) {
            if ((input.dataset.handle || '').trim() === changedHandle) {
              setSubcategoryInputActive(input, isChecked);
            } else {
              setSubcategoryInputActive(input, input.checked);
            }
          });
        });

        var subcategoryUrl = buildSubcategoryFilterUrl(root, subcategoryGroup);
        if (subcategoryUrl.origin !== window.location.origin) return;

        var nextHandles = getSelectedSubcatHandles(subcategoryGroup);

        // Multi-select: update URL only — never section-replace L2 (avoids flashing full L2 grid).
        if (nextHandles.length > 1) {
          history.pushState({ offhooCollection: true }, '', subcategoryUrl.toString());
          closeDrawer(root);
          syncCatalogFilterUi(root);
          startSubcatsCatalogMode(root);
          return;
        }

        fetchAndReplace(root, subcategoryUrl, { closeDrawer: true, pushState: true });
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var chip = target.closest('a.offhoo-subcategory-chip');
      if (chip) {
        var chipRoot = getCollectionRoot(chip);
        if (!chipRoot) return;

        var chipUrl = normalizeUrl(chip.href);
        if (chipUrl.origin !== window.location.origin) return;
        if (chipUrl.pathname.indexOf('/collections/') === -1) return;

        event.preventDefault();

        // Already on this collection chip — no-op.
        if (
          chip.classList.contains('offhoo-subcategory-chip--active') &&
          normalizePathname(chipUrl.pathname) === normalizePathname(window.location.pathname)
        ) {
          return;
        }

        // Switch collection without carrying previous collection filters.
        chipUrl.searchParams.delete('section_id');
        chipUrl.searchParams.delete('page');
        fetchAndReplace(chipRoot, chipUrl, { closeDrawer: true, pushState: true });
        return;
      }

      var openButton = target.closest('[data-offhoo-filter-open]');
      if (openButton) {
        var openRoot = getCollectionRoot(openButton);
        if (!openRoot) return;
        event.preventDefault();
        openDrawer(openRoot);
        return;
      }

      var closeButton = target.closest('[data-offhoo-filter-close]');
      if (closeButton) {
        var closeRoot = getCollectionRoot(closeButton);
        if (!closeRoot) return;
        event.preventDefault();
        closeDrawer(closeRoot);
        return;
      }

      var preserveLink = target.closest('[data-offhoo-preserve-query]');
      if (preserveLink && preserveLink.tagName === 'A') {
        var preserveRoot = getCollectionRoot(preserveLink);
        if (!preserveRoot) return;
        event.preventDefault();
        navigatePreservingQuery(preserveRoot, new URL(preserveLink.href, window.location.origin).pathname, {
          closeDrawer: true,
        });
        return;
      }

      var activeFilterLink = target.closest('a.offhoo-active-filter');
      if (activeFilterLink) {
        var activeRoot = getCollectionRoot(activeFilterLink);
        if (!activeRoot) return;
        event.preventDefault();
        fetchAndReplace(activeRoot, new URL(activeFilterLink.href, window.location.origin), {
          closeDrawer: true,
        });
        return;
      }

      var subcatClear = target.closest('[data-offhoo-subcat-clear]');
      if (subcatClear) {
        var subcatClearRoot = getCollectionRoot(subcatClear);
        if (!subcatClearRoot) return;
        event.preventDefault();

        var nextSubcatUrl = clearSubcategorySelection(subcatClearRoot, subcatClear.dataset.handle);
        if (!nextSubcatUrl || nextSubcatUrl.origin !== window.location.origin) return;

        var remaining = getActiveSubcatHandles(subcatClearRoot);

        if (remaining.length > 1) {
          history.pushState({ offhooCollection: true }, '', nextSubcatUrl.toString());
          closeDrawer(subcatClearRoot);
          syncCatalogFilterUi(subcatClearRoot);
          startSubcatsCatalogMode(subcatClearRoot);
          return;
        }

        fetchAndReplace(subcatClearRoot, nextSubcatUrl, { closeDrawer: true, pushState: true });
        return;
      }

      var priceClear = target.closest('[data-offhoo-price-clear]');
      if (priceClear) {
        var clearRoot = getCollectionRoot(priceClear);
        var clearForm = priceClear.form || (priceClear.closest && priceClear.closest('form'));
        if (!clearRoot || !clearForm) return;
        event.preventDefault();

        clearPriceFiltersOnRoot(clearRoot);
        updateCatalogOrReplace(clearRoot, urlFromForm(clearForm, clearRoot), { closeDrawer: true });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Tab') return;

      var root = getActiveCollectionRoot();
      if (!root) return;

      var drawer = root.querySelector('[data-offhoo-filter-drawer]');
      if (!drawer || drawer.hidden) return;

      if (event.key === 'Escape') {
        closeDrawer(root);
        return;
      }

      if (event.key !== 'Tab') return;

      var focusable = getFocusable(drawer);
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('click', function (event) {
      var root = getActiveCollectionRoot();
      if (!root) return;
      var drawer = root.querySelector('[data-offhoo-filter-drawer]');
      if (drawer && event.target === drawer) {
        closeDrawer(root);
      }
    });
  }

  function getProductKey(item) {
    if (item.dataset.offhooProductId) {
      return 'id:' + item.dataset.offhooProductId;
    }

    var link = item.querySelector('a[href*="/products/"]');
    if (link) {
      return 'url:' + link.getAttribute('href');
    }

    return '';
  }

  function getScrollRoot() {
    var pageWrapper = document.querySelector('.page-wrapper');

    if (pageWrapper) {
      var wrapperStyle = window.getComputedStyle(pageWrapper);
      if (wrapperStyle.overflowY === 'auto' || wrapperStyle.overflowY === 'scroll') {
        return pageWrapper;
      }
    }

    return document.scrollingElement || document.documentElement;
  }

  function getDistanceFromBottom(scrollRoot) {
    if (scrollRoot === document.documentElement || scrollRoot === document.body) {
      var doc = document.documentElement;
      return doc.scrollHeight - (window.scrollY || doc.scrollTop) - window.innerHeight;
    }

    return scrollRoot.scrollHeight - scrollRoot.scrollTop - scrollRoot.clientHeight;
  }

  function initInfiniteScroll(root) {
    cleanupInfiniteScroll(root);

    var grid = root.querySelector('[data-offhoo-product-grid]');
    var sentinel = root.querySelector('[data-offhoo-infinite-scroll]');
    var status = sentinel ? sentinel.querySelector('[data-offhoo-infinite-scroll-status]') : null;

    if (!grid || !sentinel) return;

    var loading = false;
    var finished = !sentinel.dataset.nextUrl && !sentinel.dataset.fallbackUrl;
    var offset = Number(sentinel.dataset.offset || 400);
    if (!Number.isFinite(offset) || offset < 0) {
      offset = 400;
    }

    var loadingLabel = sentinel.dataset.loadingLabel || 'Cargando...';
    var errorLabel = sentinel.dataset.errorLabel || 'No se pudieron cargar más productos';
    var endLabel = sentinel.dataset.endLabel || 'No hay más productos';
    var scrollRoot = getScrollRoot();
    var ticking = false;
    var pageAbort = null;
    var intersectionObserver = null;

    function setStatus(text) {
      if (status) {
        status.textContent = text || '';
      }
    }

    function markFinished() {
      finished = true;
      sentinel.dataset.nextUrl = '';
      sentinel.dataset.fallbackUrl = '';
      sentinel.dataset.loading = 'false';
      setStatus(endLabel);
    }

    function loadNextPage() {
      var nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl && sentinel.dataset.fallbackUrl) {
        nextUrl = sentinel.dataset.fallbackUrl;
        sentinel.dataset.nextUrl = nextUrl;
        sentinel.dataset.fallbackUrl = '';
      }

      if (!nextUrl || loading || finished) return;
      // Skip if this collection root was replaced.
      if (!root.isConnected) return;

      loading = true;
      sentinel.dataset.loading = 'true';
      setStatus(loadingLabel);

      if (pageAbort) {
        pageAbort.abort();
      }
      pageAbort = new AbortController();

      fetch(nextUrl, {
        credentials: 'same-origin',
        signal: pageAbort.signal,
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error(response.status);
          }

          return response.text();
        })
        .then(function (html) {
          if (!root.isConnected || !grid.isConnected) return;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incomingGrid = doc.querySelector('[data-offhoo-product-grid]');
          var incomingRoot = doc.querySelector('[data-offhoo-collection]');
          var requestUrl = new URL(nextUrl, window.location.href);
          var requestedSource = requestUrl.searchParams.get('feed_source');
          var requestedSection = requestUrl.searchParams.get('section_id') || '';
          var expectsFallback =
            requestedSource === 'fallback' || requestedSection.endsWith('__offhoo_product_feed_fallback');
          if (!incomingGrid) {
            throw new Error('The next product feed page did not contain a product grid.');
          }
          if (expectsFallback && (!incomingRoot || incomingRoot.dataset.feedSource !== 'fallback')) {
            throw new Error(
              'Fallback request returned source "' +
                (incomingRoot ? incomingRoot.dataset.feedSource : 'missing') +
                '" instead of "fallback".'
            );
          }
          var incomingItems = Array.from(incomingGrid.querySelectorAll('[data-offhoo-product-item]'));
          var existingKeys = new Set(
            Array.from(grid.querySelectorAll('[data-offhoo-product-item]'))
              .map(getProductKey)
              .filter(Boolean)
          );

          incomingItems.forEach(function (item) {
            var key = getProductKey(item);

            if (key && existingKeys.has(key)) return;
            if (key) {
              existingKeys.add(key);
            }

            grid.appendChild(document.importNode(item, true));
          });

          var nextSentinel = doc.querySelector('[data-offhoo-infinite-scroll]');
          var nextUrlFromPage = nextSentinel && nextSentinel.dataset.nextUrl;
          var fallbackUrlFromPage =
            (nextSentinel && nextSentinel.dataset.fallbackUrl) || sentinel.dataset.fallbackUrl;

          if (!nextUrlFromPage && fallbackUrlFromPage) {
            nextUrlFromPage = fallbackUrlFromPage;
            fallbackUrlFromPage = '';
          }

          loading = false;
          sentinel.dataset.loading = 'false';

          if (nextUrlFromPage) {
            sentinel.dataset.nextUrl = nextUrlFromPage;
            sentinel.dataset.fallbackUrl = fallbackUrlFromPage || '';
            setStatus('');
            maybeLoad();
            return;
          }

          markFinished();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          loading = false;
          if (sentinel.isConnected) {
            sentinel.dataset.loading = 'false';
          }
          console.error('[Offhoo product feed] Failed to load next page.', {
            url: nextUrl,
            error: error,
          });
          setStatus(errorLabel);
        });
    }

    function maybeLoad() {
      if (
        !root.isConnected ||
        loading ||
        finished ||
        (!sentinel.dataset.nextUrl && !sentinel.dataset.fallbackUrl)
      ) return;

      if (getDistanceFromBottom(scrollRoot) <= offset) {
        loadNextPage();
      }
    }

    function requestCheck() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        maybeLoad();
      });
    }

    window.addEventListener('scroll', requestCheck, { passive: true });
    window.addEventListener('resize', requestCheck);

    if (scrollRoot !== document.documentElement && scrollRoot !== document.body) {
      scrollRoot.addEventListener('scroll', requestCheck, { passive: true });
    }

    if ('IntersectionObserver' in window) {
      intersectionObserver = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            loadNextPage();
          }
        },
        {
          root:
            scrollRoot === document.documentElement || scrollRoot === document.body
              ? null
              : scrollRoot,
          rootMargin: offset + 'px 0px',
        }
      );
      intersectionObserver.observe(sentinel);
    }

    infiniteScrollCleanups.set(root, function () {
      window.removeEventListener('scroll', requestCheck);
      window.removeEventListener('resize', requestCheck);
      if (intersectionObserver) {
        intersectionObserver.disconnect();
      }
      if (scrollRoot !== document.documentElement && scrollRoot !== document.body) {
        scrollRoot.removeEventListener('scroll', requestCheck);
      }
      if (pageAbort) {
        pageAbort.abort();
      }
    });

    maybeLoad();
  }

  function initAll(context) {
    (context || document)
      .querySelectorAll('[data-offhoo-collection]:not(.offhoo-product-feed--fetch-only)')
      .forEach(initCollectionUi);
  }

  function flushEarlyQueue() {
    var boot = window.__offhooCollectionEarly;
    if (!boot) return;

    boot.active = false;
    var queue = boot.queue.splice(0);
    if (!queue.length) return;

    queue.forEach(function (item) {
      if (!item || !item.target || !item.target.isConnected) return;

      try {
        if (item.type === 'change') {
          item.target.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (item.type === 'click') {
          item.target.dispatchEvent(
            new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
          );
        } else if (item.type === 'submit') {
          item.target.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      } catch (error) {
        console.warn('[offhoo-collection] early queue replay failed', error);
      }
    });
  }

  // Stop early capture first, then bind real handlers, then replay queued clicks.
  if (window.__offhooCollectionEarly) {
    window.__offhooCollectionEarly.active = false;
  }

  bindDelegatedEvents();
  flushEarlyQueue();

  // Category chip async navigation uses pushState — support browser back/forward.
  window.addEventListener('popstate', function () {
    var root = getActiveCollectionRoot();
    if (!root) return;
    fetchAndReplace(root, new URL(window.location.href), { closeDrawer: true, pushState: false });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
